import * as heatmapActions from './heatmap/actions';
import heatmap from './heatmap/heatmap';
import getHeatmapRequest from './heatmap/helpers/getHeatmapRequest';
import * as suggestsActions from './suggests/actions';
import suggests from './suggests/suggests';

export default {
  actions: {
    ...heatmapActions,
    getHeatmapRequest,
    ...suggestsActions,
  },
  heatmap,
  suggests,
};
